import React from 'react'
import './ShortTechnologyStack.css';
import { FaReact, FaAndroid, FaNode, FaPhp, FaDatabase, FaAws, FaCss3Alt, FaJava, FaFigma,   } from 'react-icons/fa';
const technologies = [
    { icon: <FaReact className="tech-icon" />, title: 'React', description: 'A JavaScript library for building user interfaces.' },
    { icon: <FaAndroid className="tech-icon" />, title: 'Android Studio', description: 'The official IDE for Android app development.' },
    { icon: <FaNode className="tech-icon" />, title: 'Node.js', description: 'JavaScript runtime for server-side development.' },
    { icon: <FaPhp className="tech-icon" />, title: 'PHP', description: 'A popular server-side scripting language.' },
    { icon: <FaDatabase className="tech-icon" />, title: 'MySQL', description: 'Relational database management system.' },
    { icon: <FaDatabase className="tech-icon" />, title: 'MongoDB', description: 'NoSQL database for high volume data storage.' },
    { icon: <FaAws className="tech-icon" />, title: 'AWS', description: 'Cloud computing services for scalable infrastructure.' },
    { icon: <FaCss3Alt className="tech-icon" />, title: 'JavaScript', description: 'Programming language for web development.' },
    { icon: <FaJava className="tech-icon" />, title: 'Java', description: 'A programming language used for enterprise-level applications.' },
    { icon: <FaFigma className="tech-icon" />, title: 'Figma', description: 'Cloud-based design tool for UI/UX design.' },
    { icon: <FaFigma  className="tech-icon" />, title: 'Illustrator', description: 'Vector graphics editor for high-quality designs.' },
  ];
export default function ShortTechnologyStack() {
  return (
    <>
    <section className="technology-stack_uu7">
      <div className="container_uu7">
        <h2>Our Technology Stack</h2>
        <p>We utilize the best tools and technologies to create scalable and high-performance solutions for your business.</p>
        <div className="tech-grid_uu7">
          {technologies.map((tech, index) => (
            <div className="tech-card_uu7" key={index}>
              <div className="icon-container_uu7">{tech.icon}</div>
              <h3>{tech.title}</h3>
              <p>{tech.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
    
    
    
    
    
    </>
  )
}
